import { CONVERSATIONAL_MM_AGENT } from '@fruitful/llm-service-shared';

import { requestBuilder } from '../../../http/RequestBuilder';
import type { MastraThread } from '../../../llm-service/conversational-mm/ConversationalMoneyMap';

const useGetMembershipMastraThreads = requestBuilder.query<
    MastraThread[],
    { membershipId: string }
>({
    endpoint: ({ membershipId }) =>
        `/api/admin/memberships/${membershipId}/mastra-threads`,
    queryKey: ({ membershipId }) =>
        `getMembershipMastraThreads/${membershipId}`,
});

export const useGetMembershipConversationalMMThread = ({
    membershipId,
}: {
    membershipId: string;
}) => {
    const result = useGetMembershipMastraThreads({ membershipId });

    return {
        ...result,
        data:
            result.data
                ?.filter((t) => t.agentId === CONVERSATIONAL_MM_AGENT.id)
                .sort(
                    (a, b) =>
                        new Date(b.updatedAt).getTime() -
                        new Date(a.updatedAt).getTime(),
                )[0] ?? null,
    };
};
